import axios from '../api'

export default {
  getAll() {
    return axios.get('/projects')
  },
  getFormOptions() {
    return axios.get('/projects/create')
  },
  get(id) {
    return axios.get(`/projects/${id}`)
  },
  edit(id) {
    return axios.get(`/projects/${id}/edit`) 
  },
  create(data) {
    return axios.post('/projects', data)
  },
  update(id, data) {
    return axios.put(`/projects/${id}`, data)
  },
  delete(id) {
    return axios.delete(`/projects/${id}`)
  },
  deactivate(id) {
    return axios.patch(`/projects/${id}/deactivate`)
  }
}
